"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcommunitysm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcommunitysm` : '') + (description ? ` desc-brandedcommunitysm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcommunitysm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcommunitysm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88.88a3 3 0 1 1 4.24 4.24A3 3 0 0 1 7.88.88Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9 17.68c1.3.53 2.8.4 4-.4A2.5 2.5 0 0 0 20 15.2v-3.74A3.46 3.46 0 0 0 16.52 8c-.73 0-1.43.23-2.02.65.11.23.2.47.29.73.2.66.21 1.62.23 2.07v5.27c0 .33-.04.65-.12.96Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 8.54a3.67 3.67 0 0 0-4.45.47A3.4 3.4 0 0 0 0 11.46v3.74c0 .83.43 1.61 1.14 2.08 1.17.76 2.62.92 3.9.47a3.82 3.82 0 0 1-.14-1.03v-5.27a5.16 5.16 0 0 1 .6-2.9Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42 7.34a3.9 3.9 0 0 1 4.5.96 4.16 4.16 0 0 1 1.07 3.2v4.35c0 .9-.4 1.75-1.06 2.2a5 5 0 0 1-5.86 0 2.68 2.68 0 0 1-1.06-2.2V11.5a4.29 4.29 0 0 1 1.07-3.2 4 4 0 0 1 1.34-.96Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55 3.21a2.3 2.3 0 1 1 3.24 3.24 2.3 2.3 0 0 1-3.24-3.24Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.21 3.21a2.3 2.3 0 1 1 3.24 3.24 2.3 2.3 0 0 1-3.24-3.24Z",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = brandedcommunitysm;